import React, { createContext, useContext, useEffect, useState } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loadingState, setLoadingState] = useState([]);

  const setLoading = (newState) => {
    setLoadingState((prevStates) => [...prevStates, { ...newState }]);
  };

  const removeLoading = (id) => {
    const newState = loadingState.filter((item) => {item.id != id.id});
    setLoadingState(newState);
  };

  return (
    <LoadingContext.Provider
      value={{ loadingState, setLoading, removeLoading }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  return useContext(LoadingContext);
};